import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import CtaCards from '~/components/blocks/acf/CtaCards';

const CtaCardsBlock = ({
    attributes,
    globalBlockOptions,
    blockCtaCards: { cards }
}) => {
    return <CtaCards {...{ attributes, globalBlockOptions, cards }} />;
};

CtaCardsBlock.propTypes = {
    blockCtaCards: PropTypes.shape({
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                subtitle: PropTypes.string,
                icon: PropTypes.string,
                link: PropTypes.shape({
                    url: PropTypes.string
                })
            })
        ).isRequired
    }).isRequired
};

export default CtaCardsBlock;

export const query = graphql`
    fragment CtaCardsBlockFragment on WpAcfCtaCardsBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockCtaCards {
            cards {
                title
                subtitle
                icon
                link {
                    ... on WpAccountPage {
                        uri
                    }
                    ... on WpPage {
                        uri
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default CTA Cards',
        description: 'Simple call to action cards with icon.',
        props: {
            name: 'acf/cta-cards',
            blockCtaCards: {
                cards: [
                    {
                        title: 'Card Title',
                        subtitle:
                            'Aenean ac turpis finibus metus facilisis commodo. Ut sed congue dolor.',
                        icon: 'gear',
                        link: {
                            uri: '#'
                        }
                    },
                    {
                        title: 'Card Title 2',
                        subtitle:
                            'Aenean ac turpis finibus metus facilisis commodo. Ut sed congue dolor.',
                        icon: 'gear',
                        link: {
                            uri: '#'
                        }
                    },
                    {
                        title: 'Card Title 3',
                        subtitle:
                            'Aenean ac turpis finibus metus facilisis commodo. Ut sed congue dolor.',
                        icon: 'gear',
                        link: {
                            uri: '#'
                        }
                    },
                    {
                        title: 'Card Title 4',
                        subtitle:
                            'Aenean ac turpis finibus metus facilisis commodo. Ut sed congue dolor.',
                        icon: 'gear',
                        link: {
                            uri: '#'
                        }
                    },
                    {
                        title: 'Card Title 5',
                        subtitle:
                            'Aenean ac turpis finibus metus facilisis commodo. Ut sed congue dolor.',
                        icon: 'gear',
                        link: {
                            uri: '#'
                        }
                    }
                ]
            }
        }
    }
];
